<template>
    <p>logout</p>
</template>

<script>
export default {
    name: "Logout",
    //#######################################################
    data() {
        return {
            jwt: "",
            myInfo: [],
        };
    },
    //#######################################################
    //==================================================
    created: function () {
        this.logout();
    },
    //==================================================
    methods: {
        //====================================================
        logout: async function () {
            this.jwt = this.$localStorage.get("jwt");
            this.$localStorage.remove("jwt");
            if (this.jwt) {
                this.myInfo = this.$jwt.decode(this.jwt);
                const exp = this.$moment.unix(this.myInfo.exp).add(-10, "seconds").unix();
                const now = this.$moment().unix();
                if (now < exp) {
                    await this.axios({
                        method: "PUT",
                        url: "/web/api/user_logout",
                        headers: { Authorization: "Bearer " + this.jwt },
                        timeout: 30000,
                    });
                }
            }
            this.$router.push({ path: "/login" });
        },
        //====================================================
    },
    //==================================================
};
</script>
